<template>
    <div>
        <div :class="['page auth',{ off: !pageOn }]">
            <VHeader />
            <div :class="['page-content',host == 'rating-star' ? 'rating' : 'copper']">
                <p v-if="auth" class="auth-un" style="color: white">Currently logged in as<br>{{ auth.un }}</p>
                <label>
                    <p style="color: white;">Username</p>
                    <input id="username" autocapitalize="off" autocomplete="off" v-model="un"/>
                </label>
                <label>
                    <p style="color: white;">Password</p>
                    <input id="password" v-model="pw" type="password" @keyup="keyup($event)" />
                </label>
                <p class="btn lg" @click="login">{{ auth ? 'LOGOUT' : 'LOGIN' }}</p>
                <p class="td-ulb" style="color:lightblue;text-align:center;width: 100%; margin: 30px 0px;" @click="resetPassword">new / reset password</p>
            </div>
        </div>
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import MD5 from '@/utils/MD5.js'
import Alert from '@/utils/Alert.js'

export default {
    components: {
        VHeader
    },
    name: 'auth',
    mixins: [ pageOn ],
    computed: {
        id () { return this.$store.state.id },
        auth () { return this.$store.state.auth },
        host () { return this.$store.state.host },
        coupon () { return this.$store.state.coupon } 
    },
    wathc: {
        auth ( auth ) {
            auth && this.back();
        }
    },
    data () {
        return {
            un: '',
            pw: '',
            MDCode: '',
        }
    },
    mounted () {
        setTimeout(() => {
            WebSoc.SEND({ t: 'getResetMD5Code' },resp => {
                this.MDCode = resp.code;
                this.setValue({ k: 'MD5Code', v: resp.code });
            });
        },0);
    },
    methods: {
        back () {
            this.pageOn = false;
        },
        keyup ( e ) {
            e.keyCode == 13 && this.login();
        },
        login () {

            var { un, pw, MDCode } = this;
            
            un = un.trim();
            pw = pw.trim();

            if ( this.auth ) {
                return WebSoc.SEND({ t: 'loyaltyClientLogout', data: { auth: this.auth }},() => {
                    try {
                        ['loyalty_id','loyaltyId'].forEach(key => localStorage.removeItem(key));
                    } catch(e) {};
                    this.setAuth(false);
                    this.pageOn = false;
                    Alert.message('Logout Successful',2000);
                })
            }

            WebSoc.SEND({ t: 'loyaltyClientLogin', data: { un: un, pw: MD5.code(MDCode+MD5.code(pw)) } },resp => {
                //console.log('loyaltyClientLogin',resp);
                if ( resp.auth ) {
                    this.setAuth(resp.auth);
                    this.$emit('success');
                    this.pageOn = false;
                    this.setPages(['home']);
                    //Alert.message('Login Successful',2000);
                }
                if ( resp.error ) return Alert.message(resp.error);
            })
        },
        resetPassword () {
            this.popPage('auth')
            this.pushPage('reset');
        },
        ...mapMutations([
            'pushPage',
            'popPage',
            'setAuth',
            'setPages',
            'setValue'
        ])
    }
}
</script>

<style lang="scss">
.page.auth {
    .page-content {
        .auth-un { text-align: center; width: 100%; margin: 10px 0px; line-height: 2; font-size: 18px; }
        > * { float: left; width: 100%; }
        > p.btn { width: calc(100% - 40px); margin-top: 50px; }
        > label:nth-child(1) { margin-top: 100px; }
        input { font-size: 30px; }
    }
}
</style>